// ----- Global

export const StyleguidePageList = [
  'tokens',
  'objects',
  'components',
  'components-blocks',
  'compositions',
] as const

export type StyleguidePages = typeof StyleguidePageList[number]

export type StyleguidePageProps = {
  chapterType: StyleguidePages,
  config: StyleguideChaptersConfig
}

export type StyleguideConfig = {
  project: StyleguideProjectInfoType,
  company: StyleguideCompanyType,
  defaultPage: StyleguidePages,
  breakpoint: number,
  chapters: {
    tokens: Array<StyleguideChaptersConfig>,
    objects: Array<StyleguideChaptersConfig>,
    components: Array<StyleguideChaptersConfig>,
    compositions: Array<StyleguideChaptersConfig>
  }
}

export type StyleguideBrands = 'Blocks'

export type StyleguideChaptersConfig = {
  slug: StyleguidePages,
  title: string,
  brand?: StyleguideBrands,
  description?: string
  sections?: Array<StyleguideSectionsConfig>
  renderer?: JSX.Element
}

export type StyleguideSectionsConfig = {
  slug: string,
  title: string,
  description?: string,
  renderer: JSX.Element
}

// ----- Renderers

export type StyleguideChapterOpts = {
  type: StyleguidePages
  slug: string
  title: string
  brand?: string
  intro?: string
  extraClasses?: string
}

export type StyleguideSectionOpts = {
  type: StyleguidePages
  slug: string
  title: string
  intro?: string
  extraClasses?: string
}

export type StyleguidePartOpts = {
  title?: string
  intro?: string
  extraClasses?: string
}

export type StyleguideTokenPartOpts = {
  hasExampleColumn: boolean
  hasAttributeColumn: boolean
  extraClasses?: string
}

export type StyleguideExampleOpts = {
  showExampleLabel: boolean
  isFullScreen: boolean
  extraClasses?: string
}

export type StyleguideTokenRowOpts = {
  code: string
  description?: string
  attributes?: string | Array<string>
  columnCount: number
  hasSeparator: boolean
  hasExample: boolean
  extraClasses?: string
}

// ----- Navigation

export type StyleguideNavigationProps = {
  currentPage: StyleguidePages,
  chapterType?: StyleguidePages,
  config: StyleguideChaptersConfig
  breakpoint: number
}

// ----- Company Info

export type StyleguideCompanyType = 'hoppinger' | 'other'

export type StyleguideCompanyInfoType = {
  name: string
  url: string
}

// ----- Project Info

export type StyleguideProjectInfoType = {
  name?: string
  logoSrc?: string
}
